import React from 'react'
import LanguageContext from '../helper/LanguageContext';
import MaterialIcon from './MaterialIcon';
import './AcceptCallButton.css';


function AcceptCallButton() {
    const { strings } = React.useContext(LanguageContext);

    return (
        <div className="accept-call-button">
            <div className="video-call-icon-wrapper">
                <span className="video-call-pulse-ring"></span>
                <span className="video-call-pulse-ring"></span>
                <span className="video-call-pulse-ring"></span>
                <MaterialIcon icon="videocam" size={24} weight={300} color="var(--kjuup-accent)" />
            </div>
            <div className="video-call-icon-label accept-call-button__label">{strings.nav_call}</div>
        </div>
    )
}


export default AcceptCallButton